<template>
  <section>
    <b-card class="cissetting mb-1 sticky-top" id="userList-card">
      <b-row>
        <b-col>
          <div id="adminMenu" style="margin-left: 0rem;">
            <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="account"
            size=""
            button
            @change="adminMenuClick('account')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            ACCOUNT
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="prices"
            size=""
            button
            @change="adminMenuClick('prices')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            PRICES
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="users"
            size=""
            button
            @change="adminMenuClick('users')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            USERS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="seeds"
            size=""
            button
            @change="adminMenuClick('seeds')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SEEDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="keywords"
            size=""
            button
            @change="adminMenuClick('keywords')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            KEYWORDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="synonyms"
            size=""
            button
            @change="adminMenuClick('synonyms')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SYNONYMS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="uncategorized"
            size=""
            button
            @change="adminMenuClick('uncategorized')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            UNCATEGORIZED
          </b-form-radio>
        </div>
      </b-col>
    </b-row>
  </b-card>

    <b-card class="cissetting mb-0">
      <div class="d-flex align-items-center justify-content-between mb-1">
        <div>
          <b-form-input
            v-model="searchQuery"
            placeholder="Search..."
            type="text"
          />
        </div>
      </div>

      <b-table
        ref="refUncategorizedTable"
        responsive
        :items="fetchUncategorized"
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="해당하는 키워드가 없습니다."
        class="position-relative mb-0"
      >  
        <template #head()="data">
          <span class="text-nowrap"> {{ data.label }} </span>
          <feather-icon
            id="uncatKeywords"
            v-if="data.field.key == 'uncatKeywords'"
            icon="InfoIcon"
            class="cursor-pointer ml-1"
            size="12"
            color="#1951DC"
          />
          <feather-icon
            id="relKeywords"
            v-if="data.field.key == 'relKeywords'"
            icon="InfoIcon"
            class="cursor-pointer ml-1"
            size="12"
            color="#1951DC"
          />
          <b-tooltip target="uncatKeywords" triggers="hover" placement="topright"> 연관키워드에서 분류되지않은 토큰입니다.<br>해당 토큰이 여러개인 경우🔹로 구분하여 표시됩니다. </b-tooltip>
          <b-tooltip target="relKeywords" triggers="hover" placement="righttop"> 분류되지않은 토큰이 포함된 연관키워드 목록입니다. </b-tooltip>
        </template>
        <!-- Column: Uncategrized Token -->
        <template #cell(uncatKeywords)="data">
          <span class="text-nowrap">
            {{ data.item.uncatKeywords.replace(/\s/g, '🔹') }}
          </span>
        </template>

        <!-- Column: Related Keyword -->
        <template #cell(relKeywords)="data">
          <span class="text-nowrap">
            {{ data.item.relKeywords }}
          </span>
        </template>

        <template #cell(actions)="data">
          <div class="text-nowrap">
            <feather-icon
              id="rmKeyword"
              v-if="hasSuperAdminRole()"
              icon="FolderMinusIcon"
              class="cursor-pointer mr-1"
              size="16"
              @click="addRemoveKeyword(data.item.uncatKeywords)"
            />
            <feather-icon
              id="addPropClass"
              v-if="hasSuperAdminRole()"
              icon="FilterIcon"
              class="cursor-pointer"
              size="16"
              style="margin-left: 7px; margin-right: 10px;"
              @click="addPropCls(data.item.uncatKeywords)"
            />
            <feather-icon
              id="addIgnKeyword"
              v-if="hasSuperAdminRole()"
              icon="EyeOffIcon"
              class="cursor-pointer"
              size="16"
              @click="addIgnoreToken(data.item.uncatKeywords)"
            />
          </div>
          <b-tooltip target="rmKeyword" triggers="hover"> Remove keyword </b-tooltip>
          <b-tooltip target="addPropClass" triggers="hover"> Add Property Classification </b-tooltip>
          <b-tooltip target="addIgnKeyword" triggers="hover"> Ignore keyword </b-tooltip>
        </template>
      </b-table>

      <b-row class="mt-5">
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
            {{ dataMeta.of }} entries
          </span>
          <b-form-group class="text-nowrap mb-md-0 ml-1">
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="perPageOptions"
            />
          </b-form-group>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalUncategorized"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <add-property-class-modal
        :token="token"
        :refreshData="reFetchData"
    />
    <add-keyword-modal 
      :targetRmKeyword="targetRmKeyword"
      :refreshData="reFetchData"
    />
  </section>
</template>
    
<script>
  import {
      BCard,
      BCol,
      BRow,
      BCardBody,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BButton,
      BTable,
      BLink,
      BTooltip,
      BPagination,
      BFormRadio,
  } from "bootstrap-vue";
  import cisUncategorizedList from "@/views/cis-settings/components/cisUncategorized";
  import AddPropertyClassModal from "@/views/cis-settings/modal/AddPropertyClassModal";
  import AddKeywordModal from "@/views/cis-settings/modal/AddKeywordModal";
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
  
  import vSelect from "vue-select";
  
  import CISSettingService from '@/services/cis-setting.service'
  import CategoryService from "@/services/category.service";

  var sel_category = '9999';
 
  export default {
    name: "AdAccountUsers",
    components: {
      BCard,
      BCol,
      BRow,
      BCardBody,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BButton,
      BTable,
      BLink,
      BTooltip,
      BPagination,
      AddPropertyClassModal,
      AddKeywordModal,
      vSelect,
      BFormRadio,
    },
    data() {
      return {
        token: null,
        targetRmKeyword: null,
        selectedAdminMenu: "uncategorized",
      };
    },
    computed:{
      check_adminMenu() {
        return this.$store.getters.getSelectedAdminMenu
      },
      check_selectedCategory() {
        console.log('---------- computed // check_selectedCategory ----------')
        console.log(' sel category : ' + this.$store.getters.getSelectedCategory)
        console.log(' cur category : ' + sel_category)

        if (this.$store.getters.getSelectedCategory != '9999') {
          this.listCtgSq = this.$store.getters.getSelectedCategory
          this.getSelectedCategoryName(this.listCtgSq)
        }

        return this.$store.getters.getSelectedCategory
      },
    },
    watch: {
      check_adminMenu(value) {
        this.selectedAdminMenu = value
      },
      check_selectedCategory(val) { // 수행 기능이 존재하지 않지만 watch가 존재하지 않으면 computed 기능이 구동하지 않음
        console.log('---------- watch // check_selectedCategory ----------')
        console.log(' sel category : ' + val)
        console.log(' cur category : ' + sel_category)

        if (sel_category != val) {
          sel_category = val;

          this.getSelectedCategoryName(sel_category)

          this.loadData()
        }
      },
    },
    methods: {
      async loadData() {       
        this.listCtgSq = sel_category

        console.log('---------- loadData ----------')
        console.log(' cur category : ' + this.listCtgSq)

        this.reFetchData()
      },

      adminMenuClick(mode) {      
        this.$store.dispatch('callAdminMenu', { adminMenu: mode })
  
        switch(mode) {
          case 'account':
            this.$router.push({ name: "cis-account" }).catch(() => {});
            break;
          case 'prices':
            this.$router.push({ name: "cis-prices" }).catch(() => {});
            break;
          case 'users':
            this.$router.push({ name: "cis-users" }).catch(() => {});
            break;
          case 'seeds':
            this.$router.push({ name: "cis-seeds" }).catch(() => {});
            break;
          case 'keywords':
            this.$router.push({ name: "cis-keywords" }).catch(() => {});
            break;
          case 'synonyms':
            this.$router.push({ name: "cis-synonyms" }).catch(() => {});
            break;
          case 'uncategorized':
            this.$router.push({ name: "cis-uncategorized" }).catch(() => {});
            break;
        }
      },
       
      addPropCls(token) {
        this.token = token;
        this.$bvModal.show("add-property-class-modal");
      },

      addRemoveKeyword(token) {
        this.targetRmKeyword = token;
        this.$bvModal.show("add-keyword-modal");
      },

      addIgnoreToken(token) {
        this.$swal({
          title: "Are you sure?",
          html: `You want to add the ignore keyword from uncategorized list!<br>&nbsp;`,
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
          padding: "1rem",
        }).then(async (result) => {
          if (result.isConfirmed) {

            var ctgSq = this.$store.getters.getSelectedCategory
            if(ctgSq == '9999'){
              ctgSq = 1
            }

            const response = await CISSettingService.insIgnoreToken( { keyword: token, ctgSq: ctgSq } );

            if (response && response.status === 200) {
              this.reFetchData();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Successfully added!`,
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message || "Unknown error",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                },
              });
            }
          }
        });
      },

      async getSelectedCategoryName(value) {
        const catServResp = await CategoryService.getOneCategory(value, null);

        if (catServResp.data.success)
          this.category = catServResp.data.data.title
      }
    },

    mounted() {
      console.log('---------- mounted ----------')
      console.log(' sel category : ' + this.$store.getters.getSelectedCategory)
      console.log(' cur category : ' + sel_category)
    },
    
    destroyed() {
      console.log('---------- destroyed ----------')

      sel_category = '9999'
    },

    created() {
      console.log('---------- create ----------')
    },

    setup() {
      const {
        category,

        fetchUncategorized,
        tableColumns,
        perPage,
        currentPage,
        totalUncategorized,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUncategorizedTable,
  
        statusFilter,
  
        reFetchData,
        listCtgSq
      } = cisUncategorizedList();
  
      return {
        category,

        fetchUncategorized,
        tableColumns,
        perPage,
        currentPage,
        totalUncategorized,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUncategorizedTable,
  
        statusFilter,
  
        reFetchData,
        listCtgSq
      };
    },
    created() {
      
    },
  };
</script>
    
<style lang="scss">
  .mb-1 .sticky-top{
    align-self: flex-start;
  }

  .cissetting .card-body {
    padding: 1.0rem;
  }
    
  #adminMenu .btn-radio .btn-secondary {
    background-color: #4E86FF !important;
    border-color: #4E86FF !important;
    box-shadow: none;
  }    
  
  #adminMenu .btn-radio .btn-secondary.active {
    background-color: #1951dc !important;
    border-color: #1c5cff !important;
    // box-shadow: 0 6px 30px -6px #002896;
    // font-weight: 600;
    // font-size: 1.3rem;
  }

  .tooltip-inner {
    color: #333;
    background: #fff;
    border: 1px solid #F2F2F2;
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    filter: none;
    box-shadow: 1px 1px 1px #F2F2F2;
    font-weight: bold;
    max-width: none;
    padding: 10px;
  }
    
</style>
    